import { render } from "./UserEmailVerificationCard.vue?vue&type=template&id=10145600&scoped=true"
import script from "./UserEmailVerificationCard.vue?vue&type=script&lang=js"
export * from "./UserEmailVerificationCard.vue?vue&type=script&lang=js"

import "./UserEmailVerificationCard.vue?vue&type=style&index=0&id=10145600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10145600"]])

export default __exports__